export const fileToBase64 = (file: File) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

export const resizeImage = (
  base64String: string,
  maxWidth: number,
  maxHeight: number
) => {
  return new Promise(function(resolve) {
    // We create an image to receive the Data URI
    const img = document.createElement("img");

    // When the event "onload" is triggered we can resize the image.
    img.onload = function() {
      // We create a canvas and get its context.
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      // We set the dimensions at the wanted size.
      canvas.width = maxWidth;
      canvas.height = maxHeight;

      // We want the image to always take full height
      const height = maxHeight;
      // We want the width of the image to resize while keeping the original ratio
      const width = (img.width * maxHeight) / img.height;
      // Center the image (We need this when the image width is less than the max width)
      const x = maxWidth / 2 - width / 2;

      // We resize the image with the canvas method drawImage();
      context?.drawImage(this as HTMLImageElement, x, 0, width, height);

      const dataURI = canvas.toDataURL();

      // This is the return of the Promise
      resolve(dataURI);
    };

    // We put the Data URI in the image's src attribute
    img.src = base64String;
  });
};
